import { render, staticRenderFns } from "./ConfirmaDadosInscrito.vue?vue&type=template&id=f0087290&scoped=true"
import script from "./ConfirmaDadosInscrito.vue?vue&type=script&lang=js"
export * from "./ConfirmaDadosInscrito.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaDadosInscrito.vue?vue&type=style&index=0&id=f0087290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0087290",
  null
  
)

export default component.exports